// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","multiplePlotListPage":"multiple-plot-list-page_multiplePlotListPage__iwK1e"};